<script setup lang="ts">
import AppIcon from './AppIcon.vue';
import type { IconName } from './icons.js';
defineProps<{
  icon?: IconName | undefined;
  danger?: boolean | undefined;
  disabled?: boolean | undefined;
  hint?: string | undefined;
}>();
</script>

<template>
  <button
    type="button"
    role="menuitem"
    class="menu-item"
    :class="{ danger }"
    :disabled="disabled"
    :title="hint"
  >
    <AppIcon v-if="icon" :name="icon" />
    <span class="menu-item-text"><slot /></span>
  </button>
</template>
